import { Menu, Dropdown } from 'antd';
import { path } from 'ramda';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Icon from 'components/Icon/Icon';

import { logout } from 'modules/auth/login/data/actions';

import { selectors } from 'store/session';

const Trigger = styled.a`
  display: block;
  background: none;
  cursor: pointer;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  padding: 3px 5px;

  &:hover,
  &:active {
    color: inherit;
  }
`;

const TriggerUsername = styled.span`
  display: inline-block;
  vertical-align: middle;
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const TriggerIcon = styled(Icon.ArrowDown)`
  color: #999;
  margin-left: 10px;
  margin-bottom: -2px;
`;

const MenuItem = styled(Menu.Item)`
  padding: 0;

  a,
  button {
    margin: 0;
    padding: 12px 20px;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
  }
`;

const LogoutButton = styled.button`
  outline: none;
  width: 100%;
`;

const connector = connect(
  (state) => ({
    groupLogo:
      path(['logo', 'thumbnail'], selectors.getActiveGroup(state)) || '',
    isLoggedIn: selectors.getIsLoggedIn(state),
    isSupplier: selectors.isSupplier(state),
    user: selectors.getUser(state),
  }),
  {
    logout,
  },
);

const renderMenu = ({ logout }) => {
  return (
    <Menu>
      <Menu.Divider />
      <MenuItem>
        <LogoutButton type="button" onClick={logout}>
          Log Out
        </LogoutButton>
      </MenuItem>
    </Menu>
  );
};

const NavDropDown = ({ user, logout, isSupplier, isLoggedIn }) => {
  if (!isLoggedIn) return null;
  const userFullName =
    user.firstName && user.lastName
      ? `${user.firstName} ${user.lastName}`
      : user.username;
  return (
    <Dropdown overlay={renderMenu({ logout, isSupplier })} trigger={['click']}>
      <Trigger href="#">
        <TriggerUsername aria-label="Username">{userFullName}</TriggerUsername>
        <TriggerIcon size="12" />
      </Trigger>
    </Dropdown>
  );
};

export default connector(NavDropDown);
